<template>
  <div class="testInfo">
    <div v-if="$route.query.type == 1">
      <div class="title">主体信息</div>
      <div class="part">
        <div><span>产品名称</span>：<span>{{info.product_name}}</span></div>
        <div><span>上市时间</span>：<span>{{info.product_info.上市时间}}</span></div>
        <div><span>生产单位</span>：<span>{{info.product_info.生产单位}}</span></div>
        <!-- <div><span>责 任 人</span>：<span>{{info.product_info.责任人}}</span></div>
        <div><span>联系方式</span>：<span>{{info.product_info.联系方式}}</span></div> -->
      </div>
      <!-- <div class="title">定性检测</div>
      <div class="part">
        <div v-if="info.check_info.length==0">暂无定性检测信息</div>
        <van-steps direction="vertical" active-color="#969799" active-icon="circle" inactive-icon="circle" v-else>
          <van-step v-for="(item,index) in info.check_info" :key="index">
            <div>{{info.product_name}}，【{{item.检测项目}}】项目中检测结果【<span :style="{color:item.检测结果=='合格'?'#33D179':'#EE3D3D'}">{{item.检测结果}}</span>】,检测地点【{{item.检测单位}}】</div>
            <div>{{item.检测日期}}</div>
          </van-step>
        </van-steps>
      </div> -->
      <!-- <div class="title">生产档案</div>
      <div class="part">
        <div v-if="info.product_doc.length==0">暂无生产档案信息</div>
        <van-steps direction="vertical" active-color="#969799" active-icon="circle" inactive-icon="circle" v-else>
          <van-step v-for="(item,index) in info.product_doc" :key="index">
            <div>{{item.责任人}}，投入【{{item.投入品}}】在【{{item.生产基地}}】</div>
            <div>{{item.操作时间}}</div>
          </van-step>
        </van-steps>
      </div> -->
    </div>
    <div v-else-if="$route.query.type == 2">
      <div class="title">主体信息</div>
      <div class="part">
        <div><span>公司名称</span>：<span>{{info.company_info.name}}</span></div>
        <div><span style="letter-spacing:0.1rem;">联系人</span>：<span>{{info.company_info.contact}}</span></div>
        <div><span>联系电话</span>：<span>{{info.company_info.tel}}</span></div>
        <div><span>公司地址</span>：<span>{{info.company_info.address}}</span></div>
        <div><span>主营产品</span>：<span>{{info.company_info.desc}}</span></div>
      </div>
    </div>
    <div v-else-if="$route.query.type == 3">
      <div v-if="info.check_info_version.length==0">暂无追溯信息</div>
      <div v-else>
        <div class="part"  v-for="(item,index) in info.check_info_version" :key="index">
          <div><span>检测名称</span>：<span>{{item.name}}</span></div>
          <div><span>检测类型</span>：<span>{{item.type}}</span></div>
          <div><span>检测部门</span>：<span>{{item.fromOrg}}</span></div>
          <div><span>检测结果</span>：<span>{{item.result}}</span></div>
          <div><span>检测时间</span>：<span>{{item.inspectAt}}</span></div>
          <div><span>证明图片</span>：<span>
            <van-image
              width="1.85rem"
              height="1.85rem"
              v-for="(item,index) in item.certificateImgList"
              :src="item.url"
              :key='index'
              style="margin-right:0.35rem;"
              fit="cover"
            />
          </span>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { timestampToTime } from '@/utils/timestamp'
import { getGoodsBack } from '@/api/ticket'
export default {
  name: 'testInfo',
  data(){
    return {
      info: {check_info_version:[]},
      hygienicImgList:[],
    }
  },
  filters:{
    toDate:function(s){
      return timestampToTime(s)
    },
  },
  created(){
    getGoodsBack({id:this.$route.query.special_id,type:this.$route.query.type}).then(res=>{
      if(res.resultCode == 1){
        this.info = res.resultInfo
        if(this.$route.query.type==3){
          if(this.info.check_info_version.length>0){
            for (let i = 0;  i < this.info.check_info_version.length; i++) {
              const item = this.info.check_info_version[i]
              item.certificateImgList = []
              if(item.certificateImg.indexOf(",")==-1){//只有一张图片
                item.certificateImgList.push({url:item.certificateImg})
              }else{
                var certificateImgList = item.certificateImg.split(',')
                for (let j = 0; j < certificateImgList.length; j++) {
                  const ipI = certificateImgList[j];
                  item.certificateImgList.push({ url: ipI })
                }
              }
            }
          }
        }
      }
    })
  },
  mounted(){

  },
  methods:{
    
  }
}
</script>

<style lang="less" scoped>
.testInfo{
  background-color: #f5f5f5;
  min-height: 100%;
  overflow: hidden;
  // padding-bottom: 0.2rem;
  .title{
    width: 6.9rem;
    margin: 0.2rem auto 0;
    color: #333;
    font-weight: bold;
    font-size: 0.32rem;
  }
  .part{
    width: 6.5rem;
    margin: 0.2rem auto 0;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.1rem 0.2rem;

    >div{
      line-height: 0.61rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.32rem;
      >span:first-child{
        color: #333;
        min-width: 1.3rem;
      }
      >span:last-child{
        color: #666;
        flex-grow: 1;
        // text-align: right;
      }
    } 
  }
  .part:last-of-type{
    margin-bottom: 0.2rem;
  }
}
</style>